export default __webpack_public_path__ + "static/media/testifyFour.02dd3d44.png";